import React, { useState, useRef, useEffect } from 'react';
import JapanFlag from '../assets/japaneseFlagNew.svg';
import USFlag from '../assets/US.svg';
import '../languageDropDown/dropDown.css';

const FLAGS = { English: USFlag, Japanese: JapanFlag };
const LANGS = [
  { name: 'Japanese', flag: JapanFlag },
  { name: 'English', flag: USFlag },
];

/** EN/JP language dropdown — same look as the chatbot header, no Chakra dep. */
const AdminLangDropdown = ({ lang, setLang }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const select = (l) => {
    setLang(l);
    setOpen(false);
  };

  return (
    <div className="custom-dropdown-language" ref={ref}>
      <div className="dropdown-header" onClick={() => setOpen(!open)}>
        <div className="lang-flag-dropdown">
          <img src={FLAGS[lang] || USFlag} alt={`${lang} flag`} />
        </div>
        <span>{lang}</span>
        <svg className={`arrow ${open ? 'rotated' : ''}`} width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className={`dropdown-options ${open ? 'open' : 'close'}`}>
        {LANGS.map((l) => (
          <div key={l.name} className="dropdown-option" onClick={() => select(l.name)}>
            <img className="lang-flag-option" src={l.flag} alt={`${l.name} flag`} />
            <span>{l.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminLangDropdown;
